module.exports = __webpack_public_path__ + "assets/RetinaNarr-LightItalic.0c4c497fda10d30521fcdbc12cc0a94b.woff2";